module.exports = __webpack_public_path__ + "img/complete_your_profile.31f4e7b2.png";